import React from 'react';
import { useParams } from 'react-router';

const Contact = () => {
    const url=useParams()
    console.log(url)
    return (
        <div>
            <h1>THis is Conatct Page</h1>
        </div>
    );
};

export default Contact;